import { elementOpen, elementClose, elementVoid } from 'incremental-dom';
import { linkClick } from '../../rxjs';
import { sitePix } from '../../pixList';
import { exportedSiteData } from '../../index';
import { isNil } from '../../utils';
import './carousel.scss';
var arrowIcon = function () {
    elementOpen('svg', null, null, 'class', 'arrow-icon', 'viewBox', '0 0 56.03 100.43');
    elementVoid('polygon', "arrow", ['points', "5.82 100.42 0 94.61 44.4 50.21 0 5.82 5.82 0 56.03 50.21 5.82 100.42"]);
    elementClose('svg');
};
var portfolioPix = function (id, mediaSizes) {
    sitePix(exportedSiteData.assetBase, "portfolio/" + id);
};
var portfolioSquare = function (id, index) {
    elementOpen('a', "portfolio-link-" + id, null, 'href', "/portfolio/" + id, 'class', "portfolio-square portfolio-square-" + id + " portfolio-square-" + index, 'onclick', function (event) {
        linkClick(event, "/portfolio/" + id);
    });
    portfolioPix(id);
    elementClose('a');
};
var DirectionType;
(function (DirectionType) {
    DirectionType[DirectionType["Forward"] = 1] = "Forward";
    DirectionType[DirectionType["Backward"] = 2] = "Backward";
    DirectionType[DirectionType["None"] = 3] = "None";
})(DirectionType || (DirectionType = {}));
;
var windowWidth = window.innerWidth;
var resizeThrottle = undefined; //TODO: fix type
window.addEventListener('resize', function (e) {
    if (!isNil(resizeThrottle)) {
        clearTimeout(resizeThrottle);
    }
    resizeThrottle = setTimeout(function () {
        //   console.log(`Window resized: ${windowWidth}`);
        // FIXME: What if multiple carousels on page
        // FIXME: Listen for pco and remove listener if no carousel on page.
        if (window.innerWidth !== windowWidth) { // Don't reflow if only height changes (iPad menubar reveal)
            windowWidth = window.innerWidth;
            var el = document.querySelector('.carousel-content');
            if (el)
                fixOrder(el, DirectionType.None);
        }
        resizeThrottle = undefined;
    }, 100);
});
var start = 0;
var blocksToShow = function () {
    if (windowWidth > 1023)
        return { nodes: 5, leftani: 'shiftleft5', rightani: 'shiftright5' };
    if (windowWidth > 767)
        return { nodes: 4, leftani: 'shiftleft4', rightani: 'shiftright4' };
    if (windowWidth > 550)
        return { nodes: 3, leftani: 'shiftleft3', rightani: 'shiftright3' };
    return { nodes: 2, leftani: 'shiftleft2', rightani: 'shiftright2' };
};
var fixOrder = function (el, direction) {
    var children = el.childNodes;
    start = (start + children.length) % children.length;
    children.forEach(function (item, i) {
        var place = (i - start + children.length) % children.length;
        item.setAttribute('class', "carousel-node carousel-node-" + place);
        if (((direction === DirectionType.Forward) && (place === 0)) ||
            ((direction === DirectionType.Backward) && (place === blocksToShow().nodes - 1))) {
            item.setAttribute('style', "order: " + place + "; display: " + (place < blocksToShow().nodes ? 'block' : 'none') + ";  animation-name: fadein");
        }
        else {
            item.setAttribute('style', "order: " + place + "; display: " + (place < blocksToShow().nodes ? 'block' : 'none'));
        }
    });
};
var shiftLeft = function (el) {
    var aniListener = function (event) {
        event.target.removeEventListener('animationend', aniListener);
        start = start + 1;
        fixOrder(el, DirectionType.Backward);
    };
    var children = el.childNodes;
    children.forEach(function (item, i) {
        var place = (i - start + children.length) % children.length;
        item.setAttribute('style', "order: " + place + "; display: " + (place < blocksToShow().nodes ? 'block' : 'none') + "; animation-name: " + blocksToShow().leftani + ";");
        if (place === 0) {
            item.addEventListener('animationend', aniListener);
        }
    });
};
var shiftRight = function (el) {
    var aniListener = function (event) {
        event.target.removeEventListener('animationend', aniListener);
        start = start - 1;
        fixOrder(el, DirectionType.Forward);
    };
    var children = el.childNodes;
    children.forEach(function (item, i) {
        var place = (i - start + children.length) % children.length;
        item.setAttribute('style', "order: " + place + "; display: " + (place < blocksToShow().nodes ? 'block' : 'none') + "; animation-name: " + blocksToShow().rightani + ";");
        if (place === 0) {
            item.addEventListener('animationend', aniListener);
        }
    });
};
var carousel = function (pco, content) {
    var el = elementOpen('div', "carousel-wrapper", null, 'class', 'carousel-wrapper');
    elementOpen('div', "carousel-prev", ['class', 'carousel-prev', 'onclick', function () {
            shiftRight(el2);
        }]);
    arrowIcon();
    elementClose('div');
    var el2 = elementOpen('div', "carousel-content", ['class', 'carousel-content']);
    content();
    elementClose('div');
    elementOpen('div', "carousel-next", ['class', 'carousel-next', 'onclick', function () {
            shiftLeft(el2);
        }]);
    arrowIcon();
    elementClose('div');
    elementClose('div');
    fixOrder(el2, DirectionType.None);
};
export { carousel };
//# sourceMappingURL=index.js.map